import useIsMergeHook from "@/shared/hooks/useIsMergeHook";
import useOrders from "@/shared/hooks/useOrders";
import useIsLiveMerge from "./useIsLiveMerge";
import useLiveOrders from "./useLiveOrders";

const useLiveOrdersHook = () => {
  const isMerge = useIsMergeHook();
  const [isLiveMerge] = useIsLiveMerge();
  const { data } = useOrders(isMerge && isLiveMerge);
  const orders = useLiveOrders(data);
  return orders;
};

export default useLiveOrdersHook;
